import { render, staticRenderFns } from "./CustomInput.vue?vue&type=template&id=56b1bb37&scoped=true"
import script from "./CustomInput.vue?vue&type=script&lang=js"
export * from "./CustomInput.vue?vue&type=script&lang=js"
import style0 from "./CustomInput.vue?vue&type=style&index=0&id=56b1bb37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b1bb37",
  null
  
)

export default component.exports